module.exports = __webpack_public_path__ + "assets/images/announcement-recently-viewed-projects.png";